module.exports = __webpack_public_path__ + "img/new.ca4736cd.png";